// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { escapeForUrl } from 'lib/common';
import './ProductsTagItem.scss';

type Props = {
  name: string,
  count: number,
  onClick: (info: any) => any,
};

const ProductsTagItem = ({ name, count, onClick }: Props) => (
  <Link
    className="ProductsTagItem"
    to={`/products/tags/${escapeForUrl(name)}`}
    onClick={() => {
      onClick({ name, posts_count: count });
    }}
  >
    <div className="name">{name}</div>
    <div className="counts">{count}</div>
  </Link>
);

export default ProductsTagItem;



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagItem/ProductsTagItem.js